import { render } from "./TrainingsTable.vue?vue&type=template&id=270c4872"
import script from "./TrainingsTable.vue?vue&type=script&lang=js"
export * from "./TrainingsTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__